<template>
  <v-container class="px-6">
    <v-row>
      <v-col
        cols="12"
        xl="8"
        offset-xl="2"
      >
        <BaseTitle class="mb-6">
          {{ $t('Sign up title')}}
        </BaseTitle>
        <BaseParagraph>
          Inscription - Prépa EXCOSUP
        </BaseParagraph>
        <form @submit.prevent="submit">
          <BaseSectionHeader class="primary--text">
            Stage
          </BaseSectionHeader>
          <InternshipSignUp />
          <v-text-field
            v-model="minor"
            label="Mineure"
            v-if="needsToFillMinor"
          />
          <v-text-field
            v-model="major"
            label="Majeure"
            v-if="needsToFillMajor"
          />

          <BaseSectionHeader class="mt-10 primary--text">
            Informations étudiant
          </BaseSectionHeader>
          <v-radio-group
            v-model="title"
            required
            row
          >
            <v-radio
              label="M"
              value="M"
            />
            <v-radio
              label="Mlle"
              value="Mlle"
            />
            <v-radio
              label="Mme"
              value="Mme"
            />
          </v-radio-group>
          <v-text-field
            v-model="lastname"
            required
            label="Nom"
          />
          <v-text-field
            v-model="firstname"
            required
            label="Prénom"
          />
          <v-text-field
            v-model="birth_date"
            type="date"
            label="Date de naissance"
          />
          <v-text-field
            v-model="address"
            required
            label="Adresse"
          />
          <v-text-field
            v-model="address_2"
            label="Complément d'adresse"
          />
          <v-text-field
            v-model="city"
            required
            label="Ville"
          />
          <v-text-field
            v-model="postal_code"
            required
            label="Code postal"
          />
          <v-text-field
            v-model="mobile_phone_number"
            required
            type="tel"
            label="Numéro de téléphone"
          />
          <v-text-field
            v-model="email"
            required
            type="email"
            label="Email"
          />
          <v-text-field
            v-model="student_number"
            label="Numéro étudiant"
          />

          <BaseSectionHeader class="mt-10 primary--text">
            Scolarité
          </BaseSectionHeader>
          <v-select
            v-model="school_level"
            label="Classe"
            :items="school_levels"
          />
          <v-text-field
            v-model="school_name"
            label="Nom du lycée"
          />
          <v-text-field
            v-model="school_city"
            label="Ville du lycée"
          />

          <div v-if="session_id && session_id !== 'Seconde'">
            <BaseSectionHeader class="mt-2">
              Classe de 1ère
            </BaseSectionHeader>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 1"
                  v-model="spe_1_1ere"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_1_1ere"
                  v-model="spe_1_grade_1ere"
                  :label="`Moyenne ${spe_1_1ere}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 2"
                  v-model="spe_2_1ere"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_2_1ere"
                  v-model="spe_2_grade_1ere"
                  :label="`Moyenne ${spe_2_1ere}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 3"
                  v-model="spe_3_1ere"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_3_1ere"
                  v-model="spe_3_grade_1ere"
                  :label="`Moyenne ${spe_3_1ere}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-text-field
              v-model="average_grade_1ere"
              label="Moyenne générale"
              type="number"
              min="0"
              max="20"
              step="0.1"
            />

            <v-select
              v-model="appreciation_1ere"
              label="Appréciation 1ère"
              :items="appreciations"
            />
          </div>

          <div v-if="session_id && !['Seconde', '1ère'].includes(session_id)">
            <BaseSectionHeader class="mt-2">
              Classe de Terminale
            </BaseSectionHeader>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 1"
                  v-model="spe_1_terminale"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_1_terminale"
                  v-model="spe_1_grade_terminale"
                  :label="`Moyenne ${spe_1_terminale}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 2"
                  v-model="spe_2_terminale"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_2_terminale"
                  v-model="spe_2_grade_terminale"
                  :label="`Moyenne ${spe_2_terminale}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                sm="12"
                lg="8"
              >
                <v-select
                  label="Spécialisation 3"
                  v-model="spe_3_terminale"
                  :items="specializations"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="spe_3_terminale"
                  v-model="spe_3_grade_terminale"
                  :label="`Moyenne ${spe_3_terminale}`"
                  type="number"
                  min="0"
                  max="20"
                  step="0.1"
                />
              </v-col>
            </v-row>

            <v-text-field
              v-model="average_grade_terminale"
              label="Moyenne générale"
              type="number"
              min="0"
              max="20"
              step="0.1"
            />
            <v-select
              v-model="appreciation_terminale"
              label="Appréciation terminale"
              :items="appreciations"
            />
          </div>

          <BaseSectionHeader class="mt-10 primary--text">
            Informations parent
          </BaseSectionHeader>
          <BaseInfoText>
            Veuillez remplir les informations de l'un de vos parents
          </BaseInfoText>
          <v-radio-group
            v-model="parent_title"
            required
            row
          >
            <v-radio
              label="M"
              value="M"
            />
            <v-radio
              label="Mlle"
              value="Mlle"
            />
            <v-radio
              label="Mme"
              value="Mme"
            />
          </v-radio-group>
          <v-text-field
            v-model="parent_lastname"
            label="Nom du parent (facultatif)"
          />
          <v-text-field
            v-model="parent_email"
            type="email"
            label="Email du parent (facultatif)"
          />
          <v-text-field
            v-model="parent_address"
            required
            label="Adresse du parent"
          />
          <v-text-field
            v-model="parent_postal_code"
            required
            label="Code postal du parent"
          />
          <v-text-field
            v-model="parent_city"
            required
            label="Ville du parent"
          />
          <v-text-field
            v-model="parent_mobile_phone_number"
            required
            label="Numéro de téléphone du parent"
          />
          <BaseSectionHeader class="mt-10 primary--text">
            Conditions générales de vente
          </BaseSectionHeader>
          <v-checkbox required>
            <template v-slot:label>
              <div>
                Je reconnais avoir pris connaissance des
                <a
                  @click.stop
                  href="/cgv-public"
                  target="_blank"
                >Conditions Générales de Vente</a>.
                Le paiement d'un acompte vaut acceptation de ces CGV.
              </div>
            </template>
          </v-checkbox>
          <BaseSectionHeader class="mt-10 primary--text">
            Conditions générales de services
          </BaseSectionHeader>
          <v-checkbox required>
            <template v-slot:label>
              <div>
                Je prends acte de ce que le délai de rétractation de 14 jours ouvert par l'article L.121-20-20 du Code de
                la Consommation ne peut pas s'appliquer dès lors que la commande a été exécutée par l'envoi de liens de téléchargement,
                 je renonce donc expressément à mon droit de rétractation de 14 jours pour les produits livrés et j'accepte les
                conditions générales de services.
                du présent site et les conditions particulières de ma commande, en cochant cette case.
              </div>
            </template>
          </v-checkbox>
          <v-btn
            class="my-4"
            block
            color="success"
            type="submit"
          >S'inscrire</v-btn>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseInfoText from '@/components/BaseInfoText.vue';
import BaseParagraph from '@/components/BaseParagraph.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import InternshipSignUp from '@/views/partials/InternshipSignUp.vue';
import {
  filter, some,
  sumBy,
} from 'lodash';
import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'SignUp',
  created() {
    this.fetchYears();
  },
  data() {
    return {
      menu: false,
      showPassword: false,
      school_levels: ['Seconde', '1ère', 'Terminale', 'PASS', 'LAS 1', 'LAS 2', 'L1SPS', 'L2SPS'],
      specializations: [
        'Mathématiques (spé ou complémentaire)',
        'Physique-chimie',
        'SVT (Sciences de la Vie et de la Terre)',
        "Sciences de l'ingénieur",
        'SES (Sciences Économiques et Sociales)',
        'Histoire-géographie, géopolitique et sciences politiques',
        'Humanités, littérature et philosophie',
        'Langues, littératures et cultures étrangères',
        "Littérature et LCA (langues et cultures de l'Antiquité)",
        'Numérique et sciences informatiques',
      ],
      appreciations: ['Félicitations', 'Compliments', 'Encouragements', 'Rien'],
    };
  },
  components: {
    BaseTitle,
    BaseParagraph,
    BaseSectionHeader,
    BaseInfoText,
    InternshipSignUp,
  },
  computed: {
    ...mapState(['years']),
    ...mapGetters(['facultiesByYear']),
    ...mapFields('authentication', [
      'form.session_id',
      'form.chosen_area_of_study_id',
      'form.chosen_faculty_id',
      'form.chosen_university_id',
      'form.internship_ids',
      'form.email',
      'form.title',
      'form.lastname',
      'form.firstname',
      'form.birth_date',
      'form.student_number',
      'form.address',
      'form.address_2',
      'form.postal_code',
      'form.city',
      'form.mobile_phone_number',
      'form.parent_title',
      'form.parent_lastname',
      'form.parent_address',
      'form.parent_city',
      'form.parent_postal_code',
      'form.parent_email',
      'form.parent_mobile_phone_number',
      'form.minor',
      'form.major',
      'form.school_level',
      'form.school_name',
      'form.school_city',
      'form.spe_1_1ere',
      'form.spe_2_1ere',
      'form.spe_3_1ere',
      'form.average_grade_1ere',
      'form.spe_1_grade_1ere',
      'form.spe_2_grade_1ere',
      'form.spe_3_grade_1ere',
      'form.appreciation_1ere',
      'form.spe_1_terminale',
      'form.spe_2_terminale',
      'form.spe_3_terminale',
      'form.average_grade_terminale',
      'form.spe_1_grade_terminale',
      'form.spe_2_grade_terminale',
      'form.spe_3_grade_terminale',
      'form.appreciation_terminale',
    ]),
    computedBirthDate() {
      return this.birth_date ? moment(this.birth_date).format('L') : '';
    },
    internshipsPrice() {
      return sumBy(this.internships, (internship) => {
        if (this.internship_ids.includes(internship.id)) {
          return internship.price;
        }
        return 0;
      });
    },
    selectedInternships() {
      return filter(this.internships, (internship) => this.internship_ids.includes(internship.id));
    },
    needsToFillMinor() {
      return some(this.selectedInternships, (internship) => internship.name.toLowerCase().includes('pass'));
    },
    needsToFillMajor() {
      return some(this.selectedInternships, (internship) => internship.name.toLowerCase().includes('lass'));
    },
  },
  methods: {
    ...mapActions(['fetchYears']),
    ...mapActions('authentication', ['signUp']),
    submit() {
      this.signUp().then(() => {
        this.$router.push('/succes-inscription');
      });
    },
  },
};
</script>
